import { Bill } from './Bill';
import { Bills } from './Bills';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isBetween from 'dayjs/plugin/isBetween';
dayjs.extend(isBetween);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
export class BillGenerator {
    static generateBills(params) {
        const currentDate = params.currentDate;
        const bills = new Bills({
            currentDate: currentDate,
        });
        let billIdSequence = 0;
        for (const entry of params.amortizationSchedule.entries) {
            if (!entry.billablePeriod) {
                continue; // Skip non-billable periods
            }
            const totalDue = entry.totalPayment;
            const id = BillGenerator.generateId(billIdSequence++);
            const isDSI = entry.billingModel === 'dailySimpleInterest';
            const bill = new Bill({
                id: id,
                period: entry.term,
                dueDate: entry.periodBillDueDate,
                openDate: entry.periodBillOpenDate,
                principalDue: entry.principal,
                interestDue: entry.dueInterestForTerm,
                feesDue: entry.fees,
                totalDue: totalDue,
                amortizationEntry: entry,
                isDSIBill: isDSI,
            });
            bills.addBill(bill);
        }
        bills.sortBills();
        return bills;
    }
    static generateId(sequence) {
        //    return uuidv4();
        const sequencePrefix = sequence !== undefined ? `${sequence}-` : '';
        return 'BILL-' + sequencePrefix + Math.random().toString(36).substr(2, 9);
    }
}
